export default __webpack_public_path__ + "static/media/changi-airport.930f3ff4.jpg";